import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled from 'styled-components'

export const StyledReopeningNextCycleSectionWrapper = styled(Flexbox)`
    .reopening-checkbox-container label {
        font-weight: 500;
    }
`
